// extracted by mini-css-extract-plugin
export default {"card":"Card_card__nTRLo","lessonNotApproved":"Card_lessonNotApproved__Cnl9j","card__title":"Card_card__title__0dRIs"};